import createReducer from './createReducer';
import {
  FETCH_EDITORIAL_TAXONOMY_DETAILS,
  FETCH_EDITORIAL_TAXONOMY_DETAILS_SUCCESS,
  FETCH_EDITORIAL_TAXONOMY_DETAILS_FAILURE,
  LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS,
  LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_SUCCESS,
  LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_FAILURE,
  ENABLE_INFINITE_SCROLLING_DETAILS,
} from '../actions/editorialTaxonomyDetails';

export const initialState = {
  loading: false,
  loadingMore: false,
  infiniteScroll: false,
  error: false,
  success: false,
  details: null,
};

const handlers: any = {};

handlers[FETCH_EDITORIAL_TAXONOMY_DETAILS] = (state: any) => ({
  ...state,
  loading: true,
  infiniteScroll: false,
  success: false,
  error: false,
});

handlers[FETCH_EDITORIAL_TAXONOMY_DETAILS_SUCCESS] = (state: any, { details }: any) => ({
  ...state,
  details,
  loading: false,
  success: true,
});

handlers[FETCH_EDITORIAL_TAXONOMY_DETAILS_FAILURE] = (state: any, { error }: any) => ({
  ...state,
  error,
  loading: false,
  success: false,
});

handlers[LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS] = (state: any) => ({
  ...state,
  loadingMore: true,
  error: false,
});

handlers[LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_SUCCESS] = (
  state: any,
  { subCategories, offset, hasMore, total }: any,
) => ({
  ...state,
  loadingMore: false,
  details: state.details
    ? {
        ...state.details,
        subCategories: [...(state.details.subCategories || []), ...subCategories],
        offset,
        hasMore,
        total,
      }
    : state.details,
});

handlers[LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_FAILURE] = (state: any, { error }: any) => ({
  ...state,
  loadingMore: false,
  error,
});

handlers[ENABLE_INFINITE_SCROLLING_DETAILS] = (state: any) => ({
  ...state,
  infiniteScroll: true,
});

export default createReducer(handlers, initialState);
